<template>
  <Teleport to="body">
    <div class="overlay fixed top-15 z-50 w-full flex justify-center">
      <!-- TODO: stack multiple snackbars -->
      <SBSnackbar />
    </div>
  </Teleport>
</template>
